import sedbukData from '../../../../data/sedbuk/sedbuk_by_gc.json';
import { resolveSedbuk } from '@core/resolveSedbuk';

type SedbukEntry = {
  make: string;
  model: string;
  sedbuk: number;
  band: string;
  type: string;
  source: string;
};

const sedbukEntries = Object.entries(sedbukData.data as Record<string, SedbukEntry>);

export type BoilerMatch = {
  make: string;
  model: string;
  gcNumber: string;
  sedbuk: number;
  band: string;
};

export const listBoilerMakes = (): string[] => {
  const makes = new Set<string>();
  sedbukEntries.forEach(([, entry]) => {
    if (entry.make) {
      makes.add(entry.make);
    }
  });
  return Array.from(makes).sort((a, b) => a.localeCompare(b));
};

export const listBoilerModels = (make: string): string[] => {
  if (!make) return [];
  const models = new Set<string>();
  sedbukEntries.forEach(([, entry]) => {
    if (entry.make === make && entry.model) {
      models.add(entry.model);
    }
  });
  return Array.from(models).sort((a, b) => a.localeCompare(b));
};

export const findBoilerMatch = (make?: string, model?: string): BoilerMatch | null => {
  if (!make || !model) return null;
  const result = resolveSedbuk({ make, model });
  return result.matchedBoiler
    ? {
        make: result.matchedBoiler.make,
        model: result.matchedBoiler.model,
        gcNumber: result.matchedBoiler.gcNumber,
        sedbuk: result.matchedBoiler.sedbuk,
        band: result.matchedBoiler.band,
      }
    : null;
};

export const formatGcNumber = (value: string): string => {
  const digits = value.replace(/\D/g, '').slice(0, 7);
  if (digits.length <= 2) return digits;
  if (digits.length <= 5) return `${digits.slice(0, 2)}-${digits.slice(2)}`;
  return `${digits.slice(0, 2)}-${digits.slice(2, 5)}-${digits.slice(5, 7)}`;
};
